import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class TennisHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="tennis"
      title="Tennis News & Betting Tips"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Tennis/containers/TennisHomePage.js